// reusable function to listen for clicks outside of dom element
export const onClickOutsideOf = (element, cb) => {
    const outsideClickListener = (event) => {
        if (!element.contains(event.target)) {
            cb()
        }
    }

    document.addEventListener('click', outsideClickListener)
    return outsideClickListener
}

// IE user agent sniffing (I know, gross)
export const detectIE = () => {
    const sAgent = window.navigator.userAgent
    const idx = sAgent.indexOf('MSIE')

    // If IE, return version number.
    if (idx > 0) {
        return parseInt(sAgent.substring(idx + 5, sAgent.indexOf('.', idx)), 10)
    }

    // If IE 11 then look for Updated user agent string.
    else if (!!navigator.userAgent.match(/Trident\/7\./)) {
        return 11
    }

    return false
}

// Reusable Focus Trap Method
export const createFocusTrap = (el, opt = {}) => {
    let isActive = false

    const focusableElementSelectors = [
        'a[href]',
        'area[href]',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'button:not([disabled])',
        'iframe',
        'object',
        'embed',
        '[contenteditable]',
        '[tabindex]:not([tabindex^="-"])'
    ]
    const focusableElements = el.querySelectorAll(
        focusableElementSelectors.join(', ')
    )
    const firstFocusableElement = focusableElements[0]
    const lastFocusableElement = focusableElements[focusableElements.length - 1]

    const defaults = {
        toggleElement: focusableElements[0],
        escape: true,
        moveInitialFocus: false,
        moveLastFocus: false,
        onEscape: () => {}
    }
    const options = Object.assign({}, defaults, opt)

    const handleKeyPress = (e) => {
        if (!isActive || e.ctrlKey || e.metaKey || e.altKey) {
            return
        }
        switch (e.keyCode) {
            case 27: // ESC
                if (options.escape) {
                    options.onEscape()
                    if (options.toggleElement) {
                        options.toggleElement.focus()
                    }
                }
                break

            case 9: // TAB
                if (e.shiftKey) {
                    if (document.activeElement === firstFocusableElement) {
                        lastFocusableElement.focus()
                        e.preventDefault()
                    }
                } else if (document.activeElement === lastFocusableElement) {
                    if (options.moveLastFocus) {
                        options.toggleElement.focus()
                    } else {
                        firstFocusableElement.focus()
                    }
                    e.preventDefault()
                }
                break

            default:
                break
        }
    }

    function activate() {
        isActive = true
        if (options.moveInitialFocus) {
            firstFocusableElement.focus()
        }
        el.addEventListener('keydown', handleKeyPress)
    }
    function deactivate() {
        isActive = false
        el.removeEventListener('keydown', handleKeyPress)
    }

    return {
        activate,
        deactivate
    }
}

export const getScrollY = () => {
    return typeof window.scrollY !== 'undefined'
        ? window.scrollY
        : window.scrollTop
}

// helper function to detect if we're in an iframe or not
export const isInFrame = () => {
    try {
        return window.self !== window.top
    } catch (err) {
        return true
    }
}

export const loadGTMScript = (id) => {
    var w = window
    var d = document
    var s = 'script'
    var l = 'dataLayer'

    w[l] = w[l] || []
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
    var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l !== 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + id + dl
    f.parentNode.insertBefore(j, f)
}

export const hasLocalStorageSupport = () => {
    try {
        if ('localStorage' in window) {
            localStorage.setItem('__test', 'test')
            localStorage.removeItem('__test')
            return true
        }
        return false
    } catch (e) {
        return false
    }
}
